// AUTO-GENERATED CODE, DO NOT EDIT!
/* eslint-disable */

import * as Types from "../../../../../types";

import gql from "graphql-tag";
import * as Urql from "urql";
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type CompanyLogoQueryVariables = Types.Exact<{ [key: string]: never }>;

export type CompanyLogoQuery = {
  __typename?: "Query";
  me?: { __typename?: "User"; companyLogoUrl?: string | null } | null;
};

export const CompanyLogoDocument = gql`
  query CompanyLogo {
    me {
      companyLogoUrl
    }
  }
`;

export function useCompanyLogoQuery(
  options?: Omit<Urql.UseQueryArgs<CompanyLogoQueryVariables>, "query">
) {
  return Urql.useQuery<CompanyLogoQuery, CompanyLogoQueryVariables>({
    query: CompanyLogoDocument,
    ...options,
  });
}
